import {isTimeRegistrationNoteRequired} from '../../cache/TimeRegistrationSettingsUtil';

export function isTimeRegistrationNoteInvalid(notes: string | null): boolean {
	return isTimeRegistrationNoteRequired() && (!notes || notes.trim().length <= 0);
}
